import { render } from "./Loader.vue?vue&type=template&id=69b5cc89&scoped=true&ts=true"
import script from "./Loader.vue?vue&type=script&lang=ts"
export * from "./Loader.vue?vue&type=script&lang=ts"

import "./Loader.vue?vue&type=style&index=0&id=69b5cc89&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69b5cc89"]])

export default __exports__